import { ChevronDownIcon } from 'lucide-react'

import { cn } from '@/infra'

export interface IChevronIndicatorProps {
  open: boolean
  size?: number
  className?: string
}

export const ChevronIndicator = ({ open, size = 16, className }: Readonly<IChevronIndicatorProps>) => (
  <ChevronDownIcon
    aria-hidden
    size={size}
    className={cn('shrink-0 transition-transform', open && 'rotate-180', className)}
  />
)
